const studioSetupActionTypes = {
  STUDIO_FETCH_DOWNLOAD_REQUEST: 'STUDIO_FETCH_DOWNLOAD_REQUEST',
  STUDIO_FETCH_DOWNLOAD_FAILURE: 'STUDIO_FETCH_DOWNLOAD_FAILURE',
  STUDIO_FETCH_DOWNLOAD_SUCCESS: 'STUDIO_FETCH_DOWNLOAD_SUCCESS',
};

export default studioSetupActionTypes;
